import { render } from "./RelationModal.vue?vue&type=template&id=5e2c6906"
import script from "./RelationModal.vue?vue&type=script&lang=js"
export * from "./RelationModal.vue?vue&type=script&lang=js"

import "./RelationModal.vue?vue&type=style&index=0&id=5e2c6906&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__